function WordListArea(props: any) {
  let myProps = {
    Style: {},
    templete_data_json: {},
    ...props
  };
  let Style = myProps.Style || {};
  let templete_data_json = myProps.templete_data_json || {};

  const get_word_list_row_tags = () => {
    let row_tags: any = [];
    let word_arr = templete_data_json.word_arr || [];
    let repeat_cnt = templete_data_json.repeat_cnt || 5;
    let word_split_cnt = 1;
    if (repeat_cnt != 0) {
      word_split_cnt = Math.ceil(repeat_cnt / 5);
    }
    let word_idx = 0;
    for (let row_i = 0; row_i < templete_data_json.row_cnt; row_i++) {
      let word_str = "";
      let mean_str = "";
      if (row_i % word_split_cnt == 0) {
        if (word_arr[word_idx]) {
          if (templete_data_json.is_print_word) {
            word_str = word_arr[word_idx].a_word;
          }
          if (templete_data_json.is_print_mean) {
            mean_str = word_arr[word_idx].a_mean;
          }
          word_idx++;
        }
      }
      row_tags.push(
        <div key={row_i} className={Style.word_line_list_row}>
          <div className={Style.word_line_row_middle_line1}></div>
          <div className={Style.word_line_row_middle_line2}></div>
          <div className={Style.word_line_row_word_wrap}>
            <span className={Style.word_line_row_word_span}>{word_str}</span>
          </div>
          <span className={Style.word_line_row_mean_span}>{mean_str}</span>
        </div>
      );
    }
    return row_tags;
  };

  return (
    <div className={Style.word_line_list_wrap}>
      {get_word_list_row_tags()}
    </div>
  );
};
export default WordListArea;